const lang = '_nl'

export { lang }



// WEBPACK FOOTER //
// ./src/language.js